import React, { FC } from 'react'

import { gql, useQuery } from '@apollo/client'

import useEvent from 'Hooks/useEvent'
import { Location } from 'Types'

const LOCATIONS = gql`
  query Locations {
    locations {
      nodes {
        id
        name
      }
    }
  }
`

interface Props {
  onChange(value: string): void
  value: string
}

const LocationSelect: FC<Props> = ({ value, onChange }) => {
  const { data: locationsData } = useQuery(LOCATIONS)
  const locations: Location[] = locationsData?.locations.nodes || []

  const handleChange = useEvent((e) => {
    onChange(e.target.value)
  })

  return locations.length > 1 ? (
    <>
      <label className="sr-only" htmlFor="location_id">
        Select location
      </label>
      <select
        className="chatBox__location / form-control"
        id="location_id"
        name="location_id"
        value={`${value}`}
        onChange={handleChange}
      >
        {locations.map((location) => (
          <option key={location.id} value={location.id}>
            {location.name}
          </option>
        ))}
      </select>
    </>
  ) : null
}

export default LocationSelect
